import React from 'react'
import { useSelector } from 'react-redux'
import { IntegrationType } from '../../@types/config'
import { ReduxState } from '../../store/reducers'

export const BlueHighlighterIcon = ({ className }: { className?: string }): React.JSX.Element => {
  const integrationType = useSelector((state: ReduxState) => state.config.integrationType)

  return (
    <>
      {integrationType === IntegrationType.IMMOBILIENSCOUT24 && (
        <img
          src={
            'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/2dcd875a67b9f93db2b06ae4c63e7d7f_Shape.svg'
          }
          alt={''}
          className={className}
          aria-hidden={true}
        />
      )}
    </>
  )
}
